import {
	CATEGORY_FILTER_ID,
	appliedFiltersCountAtom,
	filterValuesAtom,
	isAllCategoriesPageAtom,
} from '@pages/VendorsSearch/containers/FilterPills/atoms';
import { useAppSelector } from '@redux/hooks';
import { GridRow } from '@tkww/orion-web-ds-structure';
import { useAtomValue } from 'jotai';
import React from 'react';
import Styles from './styles.scss';

const PageDescription = () => {
	const appliedFiltersCount = useAtomValue(appliedFiltersCountAtom);
	const filterValues = useAtomValue(filterValuesAtom);
	const isAllCategoriesPage = useAtomValue(isAllCategoriesPageAtom);
	// Cross-category experiment pre-selects the route's category as a filter; on the all-categories page a selected category is a real filter.
	const categoryValue = filterValues.find(
		(fv) => fv.id === CATEGORY_FILTER_ID,
	)?.value;
	const preSelectedCategoryCount =
		!isAllCategoriesPage &&
		Array.isArray(categoryValue) &&
		categoryValue.length === 1
			? 1
			: 0;
	const filterCount = Math.max(
		0,
		appliedFiltersCount - preSelectedCategoryCount,
	);
	const description = useAppSelector((state) => state.search.searchCopy);
	const page = useAppSelector((state) => state.search?.pagination?.page);
	if (filterCount !== 0 || description === '' || page !== 1) {
		return null;
	}

	return (
		<GridRow>
			<div className={Styles.wrapper}>
				<div
					className={Styles.descriptionContainer}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			</div>
		</GridRow>
	);
};

export default PageDescription;
